import * as api from 'App/api/items'
import * as positioningActions from 'App/modules/positioning'
import * as captchaApi from 'App/api/captcha'
import * as categoriesActions from 'App/modules/categories'
import { uploadFile } from 'App/services/FileUploadService'
// eslint-disable-next-line camelcase
import { file_placeholder } from 'common/images/remote/urls.json'
import { ITEM_SOURCES } from 'shared/constants'
import { ITEM_AVAILABILITY } from './constants'
import update from 'immutability-helper'
import omit from 'lodash/omit'
import merge from 'lodash/merge'
import concat from 'lodash/concat'
import without from 'lodash/without'
import map from 'lodash/map'

export const FETCH_ITEMS = 'items/FETCH_ITEMS'
export const FETCH_ITEMS_SUCCESS = 'items/FETCH_ITEMS_SUCCESS'
export const FETCH_ITEM_SUCCESS = 'items/FETCH_ITEM_SUCCESS'
export const FETCH_ITEM_FAILURE = 'items/FETCH_ITEM_FAILURE'
export const FETCH_ITEM_IMAGE_SUCCESS = 'items/FETCH_ITEM_IMAGE_SUCCESS'
export const CREATE_ITEM = 'items/CREATE_ITEM'
export const COPY_ITEM = 'items/COPY_ITEM'
export const DELETE_ITEM = 'items/DELETE_ITEM'
export const CREATE_ITEM_SUCCESS = 'items/CREATE_ITEM_SUCCESS'
export const CREATE_FILE_ITEM_SUCCESS = 'items/CREATE_FILE_ITEM_SUCCESS'
export const CREATE_MANY_ITEMS = 'items/CREATE_MANY_ITEMS'
export const COPY_ITEM_SUCCESS = 'items/COPY_ITEM_SUCCESS'
export const CREATE_MANY_ITEMS_SUCCESS = 'items/CREATE_MANY_ITEMS_SUCCESS'
export const UPDATE_ITEM_SUCCESS = 'items/UPDATE_ITEM_SUCCESS'
export const DELETE_ITEM_SUCCESS = 'items/DELETE_ITEM_SUCCESS'
export const UPDATE_ITEM_STATUS = 'items/UPDATE_ITEM_STATUS'
export const IMPORT_CONTENT_ITEM = 'items/IMPORT_CONTENT_ITEM'
export const IMPORT_CONTENT_ITEM_SUCCESS = 'items/IMPORT_CONTENT_ITEM_SUCCESS'
export const ADD_CONTENT_ITEM_TO_BOARD = 'items/ADD_CONTENT_ITEM_TO_BOARD'
export const ADD_CONTENT_ITEM_TO_BOARD_SUCCESS = 'items/ADD_CONTENT_ITEM_TO_BOARD_SUCCESS'
export const DETACH_ITEM = 'items/DETACH_ITEM'
export const DETACH_ITEM_SUCCESS = 'items/DETACH_ITEM_SUCCESS'
export const FETCH_ITEM_CANONICAL_CATEGORIES_SUCCESS = 'items/FETCH_ITEM_CANONICAL_CATEGORIES_SUCCESS'
const UPDATE_ARTICLE_ITEM = 'items/UPDATE_ARTICLE_ITEM'

const ITEM_NOT_FOUND_STATUS = 404

export function getAvailabilityParams (item) {
  const isPublic = item.availability === ITEM_AVAILABILITY.public

  return {
    is_public: isPublic
  }
}

export function fetchItems (boardId, params = {}) {
  return dispatch => {
    dispatch({
      type: FETCH_ITEMS,
      boardId
    })

    return api.fetchItems(boardId, params)
      .then(items => {
        dispatch({
          type: FETCH_ITEMS_SUCCESS,
          boardId,
          ...items
        })

        return items
      })
  }
}

export function fetchItem (boardId, itemId) {
  return dispatch => {
    return api.fetchItem(itemId)
      .then(item => {
        dispatch({
          type: FETCH_ITEM_SUCCESS,
          boardId,
          item
        })

        return item
      })
      .catch(e => {
        if (e.response && e.response.status === ITEM_NOT_FOUND_STATUS) {
          // deleted item - fetchItemError flag or value
          dispatch({
            type: FETCH_ITEM_FAILURE,
            boardId,
            itemId
          })
        }
      })
  }
}

export function fetchItemCanonicalCategories (itemId) {
  return (dispatch, getState) => {
    const boardId = getState().boardView.currentBoard.id
    return api.fetchItemCanonicalCategories(itemId)
      .then(canonicalCategories => {
        dispatch({
          type: FETCH_ITEM_CANONICAL_CATEGORIES_SUCCESS,
          canonicalCategories,
          boardId,
          itemId
        })
      })
  }
}

export function createItem (params) {
  return (dispatch) => {
    return api.createItem({ ...params, ...getAvailabilityParams(params) })
      .then(item => {
        dispatch({
          type: CREATE_ITEM_SUCCESS,
          boardId: item.board_id,
          item,
          trackingParams: {
            item_id: item.id,
            ...params
          }
        })

        return item
      })
  }
}

export function copyItem (itemId, boardId, targetBoardId) {
  return (dispatch) => {
    dispatch({
      type: COPY_ITEM,
      targetBoardId,
      boardId,
      itemId
    })

    return api.copyItem(itemId, targetBoardId)
      .then(item => {
        dispatch({
          type: COPY_ITEM_SUCCESS,
          boardId: targetBoardId,
          item,
          trackingParams: {
            board_id: boardId,
            target_board_id: targetBoardId,
            item_id: item.id,
            item_name: item.title
          }
        })

        return item
      })
  }
}

export function updateItemSlug (item) {
  return (dispatch, getState) => {
    const { board_id: boardId, id: itemId } = item

    const previousItem = getState().items.data[boardId][itemId]
    return api.setItemSlug(itemId, item.slug)
      .then(item => {
        dispatch({
          type: UPDATE_ITEM_SUCCESS,
          previousItem,
          boardId,
          item
        })

        return item
      })
  }
}

export function updateItem (item) {
  return (dispatch, getState) => {
    const previousItem = getState().items.data[item.board_id][item.id]

    return api.updateItem({
      ...item,
      ...getAvailabilityParams(item),
      position: item.position.all
    })
      .then(item => {
        dispatch({
          type: UPDATE_ITEM_SUCCESS,
          previousItem,
          boardId: item.board_id,
          item,
          trackingParams: {
            board_id: item.board_id,
            item_id: item.id,
            ...omit(item, 'id')
          }
        })

        return item
      })
  }
}

export function deleteItem (boardId, itemId) {
  return (dispatch, getState) => {
    const item = getState().items.data[boardId][itemId]
    dispatch({
      type: DELETE_ITEM,
      item
    })

    return api.deleteItem(itemId)
      .then(() => {
        dispatch({
          type: DELETE_ITEM_SUCCESS,
          boardId,
          itemId,
          itemStatus: item.item_visibility.status,
          trackingParams: {
            board_id: boardId,
            item_id: itemId,
            item_name: item.title
          }
        })
      })
  }
}

// poor solution until push notifications will be implemented
const MAX_RETRIES = 36
export function fetchItemUntilImagePresent (item, retry = 1) {
  return (dispatch) => {
    if (retry > MAX_RETRIES) {
      return
    }

    return api.fetchItem(item.id)
      .then(item => {
        // eslint-disable-next-line camelcase
        if (item.image.url === file_placeholder) {
          setTimeout(() => {
            fetchItemUntilImagePresent(item, retry + 1)(dispatch)
          }, 5000)
        } else {
          dispatch({
            type: FETCH_ITEM_IMAGE_SUCCESS,
            boardId: item.board_id,
            itemId: item.id,
            image: item.image
          })
        }
      })
  }
}

function createFileItem (file, params) {
  return uploadFile(file, {
    detectDuplicates: true,
    organizationId: params.organization_id,
    allowReplaceDuplicateWithExisting: true
  })
    .then(async (result) => {
      let fileParams = {}
      if (result.content_item_id) {
        fileParams = {
          ...params,
          ...result
        }
      } else {
        fileParams = {
          ...params,
          file_id: result.file_id,
          storage_provider_id: result.file_provider_type,
          file_meta: result.file_meta
        }
      }

      const res = await api.createItem(fileParams)
      return {
        ...res,
        processingFileName: file.name
      }
    })
}

export function createBoxItem (file, params) {
  const fileParams = {
    ...params,
    file_id: file.id,
    file_meta: file.file_meta
  }

  return api.createItem(fileParams)
}

function createSingleFileItem(file, params, action, dispatch) {
  const fileParams = {
    ...params,
    title: file.name,
    file_name: file.name,
    image: {
      // eslint-disable-next-line camelcase
      url: file_placeholder,
      fit: 'cover'
    }
  }

  return action(file, fileParams)
    .then(item => {
      dispatch({
        type: CREATE_FILE_ITEM_SUCCESS,
        boardId: item.board_id,
        item
      })
      return item
    })
}

export function createFileItems(params) {
  return (dispatch) => {
    const action = params.item_source === ITEM_SOURCES.file ? createFileItem : createBoxItem
    return params.files.map(file => createSingleFileItem(file, params, action, dispatch))
  }
}

export function getCaptchaGuid(boardId, captcha) {
  return captchaApi.getGuidForCaptcha(`add_item:${boardId}`, captcha)
}

export function changeItemPosition ({
  droppedItem,
  items,
  targetId,
  boardId,
  itemIds,
  selectedCategoryId,
  dropDirection
}) {
  return dispatch => {
    return positioningActions.changeItemPosition({
      droppedItem,
      targetId,
      items,
      boardId,
      itemIds,
      selectedCategoryId,
      dropDirection
    })(dispatch)
  }
}

export function updateItemStatus (item, itemVisibility) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ITEM_STATUS,
      boardId: item.board_id,
      itemId: item.id,
      status: itemVisibility.status
    })

    return api.updateItemStatus(item.id, itemVisibility)
  }
}

export function importContentItem (board, params) {
  return (dispatch) => {
    dispatch({
      type: IMPORT_CONTENT_ITEM,
      contentItemId: params.content_item_id,
      board
    })

    return api.createItem(params)
      .then(item => {
        dispatch({
          type: IMPORT_CONTENT_ITEM_SUCCESS,
          boardId: item.board_id,
          item,
          trackingParams: {
            item_id: item.id,
            board_id: item.board_id,
            ...params
          }
        })

        return item
      })
  }
}

export function addContentItemToBoard (board, params) {
  return (dispatch) => {
    dispatch({
      type: ADD_CONTENT_ITEM_TO_BOARD,
      contentItemId: params.content_item_id,
      board
    })

    return api.createItem(params)
      .then(item => {
        dispatch({
          type: ADD_CONTENT_ITEM_TO_BOARD_SUCCESS,
          boardId: item.board_id,
          item,
          trackingParams: {
            item_id: item.id,
            board_id: item.board_id,
            ...params
          }
        })

        return item
      })
  }
}

export function detachItem (itemId, boardId) {
  return (dispatch) => {
    dispatch({
      type: DETACH_ITEM,
      itemId,
      boardId
    })

    return api.detachItem(itemId)
      .then(item => {
        dispatch({
          type: DETACH_ITEM_SUCCESS,
          boardId: item.board_id,
          item,
          trackingParams: {
            item_id: item.id,
            board_id: item.board_id
          }
        })

        return item
      })
  }
}

export function updateArticleItem (itemId, boardId, params) {
  return {
    type: UPDATE_ARTICLE_ITEM,
    itemId,
    boardId,
    params
  }
}

const boardInitialState = {}

const initialState = {
  isLoading: false,
  data: {
    // [boardId]: {
    //   [itemId]: {},
    //   [itemId]: {}
    // }
  }
}

const itemInitialState = {
  // audience_permissions:
  // board_id:
  // categories_ids:
  // creator_user: {id: , full_name: }
  // full_name:
  // id:
  // description:
  // id:
  // image: {url: ,fit: }
  // fit:
  // url:
  // item_source:
  // item_type:
  // likes_count:
  // link_settings: {open_in_new_tab: }
  // open_in_new_tab:
  // position: {
  //    all:
  //    category_id:
  // }
  // all:
  // publik_links: {
  //  all: text,
  //  [category_id]: text,
  //  [category_id]: text,
  // }
  // title:
  // url:
  // views_count:
  // item_visibility: {
  //   status:
  //   start_date:
  //   end_date:
  // },
  // canonicalCategories: [],
  // created_at
}

export function prepareInitialState () {
  return initialState
}

function item (state = itemInitialState, action) {
  switch (action.type) {
    case categoriesActions.ADD_ITEM_TO_CATEGORY:
      return {
        ...state,
        categories_ids: update(state.categories_ids, { $push: [action.categoryId] })
      }
    case categoriesActions.REMOVE_SUBCATEGORY: {
      const subcategoryIdIndex = state.categories_ids.indexOf(action.subcategory.id)
      if (subcategoryIdIndex >= 0) {
        return {
          ...state,
          categories_ids: update(state.categories_ids, { $splice: [[subcategoryIdIndex, 1]] })
        }
      } else {
        return state
      }
    }
    case categoriesActions.REMOVE_CATEGORY: {
      return {
        ...state,
        categories_ids: without(
          state.categories_ids,
          action.category.id, ...action.category.subcategories_ids
        )
      }
    }
    case FETCH_ITEM_IMAGE_SUCCESS:
      return {
        ...state,
        image: action.image
      }
    case UPDATE_ITEM_STATUS: {
      return {
        ...state,
        item_visibility: {
          ...state.item_visibility,
          status: action.status
        }
      }
    }
    case positioningActions.CHANGE_ITEM_POSITION:
      return {
        ...state,
        position: {
          ...state.position,
          [action.categoryId]: action.position
        }
      }
    case FETCH_ITEM_FAILURE:
      return {
        ...state,
        isDeleted: true
      }
    case COPY_ITEM:
      return {
        ...state,
        can_edit_content: false
      }
    case DETACH_ITEM:
      return {
        ...state,
        isDetaching: true
      }
    case FETCH_ITEM_CANONICAL_CATEGORIES_SUCCESS:
      return {
        ...state,
        canonicalCategories: action.canonicalCategories
      }
    case UPDATE_ARTICLE_ITEM:
      return {
        ...state,
        ...action.params
      }
    default:
      return state
  }
}

function boardItems (state = boardInitialState, action) {
  switch (action.type) {
    case FETCH_ITEMS_SUCCESS:
    case CREATE_MANY_ITEMS_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case CREATE_FILE_ITEM_SUCCESS:
    case CREATE_ITEM_SUCCESS:
    case UPDATE_ITEM_SUCCESS:
    case COPY_ITEM_SUCCESS:
    case FETCH_ITEM_SUCCESS:
    case IMPORT_CONTENT_ITEM_SUCCESS:
    case ADD_CONTENT_ITEM_TO_BOARD_SUCCESS:
    case positioningActions.CHANGE_ITEM_POSITION:
      return {
        ...state,
        [action.item.id]: action.item
      }
    case categoriesActions.ADD_ITEM_TO_CATEGORY:
    case FETCH_ITEM_CANONICAL_CATEGORIES_SUCCESS:
    case FETCH_ITEM_IMAGE_SUCCESS:
    case UPDATE_ITEM_STATUS:
    case FETCH_ITEM_FAILURE:
    case COPY_ITEM:
    case DETACH_ITEM:
    case UPDATE_ARTICLE_ITEM:
      return {
        ...state,
        [action.itemId]: item(state[action.itemId], action)
      }
    case DELETE_ITEM_SUCCESS:
      return {
        ...omit(state, action.itemId)
      }
    case categoriesActions.REMOVE_SUBCATEGORY:
    case categoriesActions.REMOVE_CATEGORY: {
      return map(state, (stateItem) => item(stateItem, action))
        .reduce((result, i) => merge(result, { [i.id]: i }), {})
    }
    case DETACH_ITEM_SUCCESS:
      return {
        ...state,
        [action.item.id]: {
          ...action.item,
          isDetaching: false
        }
      }
    default:
      return state
  }
}

export default function items (state = initialState, action) {
  switch (action.type) {
    case FETCH_ITEMS:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ITEM_SUCCESS:
    case FETCH_ITEM_FAILURE:
    case CREATE_ITEM_SUCCESS:
    case UPDATE_ITEM_SUCCESS:
    case CREATE_FILE_ITEM_SUCCESS:
    case COPY_ITEM_SUCCESS:
    case FETCH_ITEMS_SUCCESS:
    case FETCH_ITEM_IMAGE_SUCCESS:
    case CREATE_MANY_ITEMS_SUCCESS:
    case DELETE_ITEM_SUCCESS:
    case UPDATE_ITEM_STATUS:
    case IMPORT_CONTENT_ITEM_SUCCESS:
    case ADD_CONTENT_ITEM_TO_BOARD_SUCCESS:
    case COPY_ITEM:
    case DETACH_ITEM:
    case DETACH_ITEM_SUCCESS:
    case categoriesActions.REMOVE_CATEGORY:
    case categoriesActions.REMOVE_SUBCATEGORY:
    case categoriesActions.ADD_ITEM_TO_CATEGORY:
    case positioningActions.CHANGE_ITEM_POSITION:
    case FETCH_ITEM_CANONICAL_CATEGORIES_SUCCESS:
    case UPDATE_ARTICLE_ITEM:
      return {
        isLoading: false,
        data: {
          ...state.data,
          [action.boardId]: boardItems(state.data[action.boardId], action)
        }
      }
    default:
      return state
  }
}
